import styled from 'styled-components/macro';
import { DropDownListHolderStyled } from '../autocomplete-request/DropDownResults/styled';
import { SpinnerLoader } from '../spinner-loader';
import { SpinnerLoaderMaskStyled } from '../spinner-loader/styled';
export const ContainerStyled = styled.div `
  input {
    ${({ isRightToLeft }) => (isRightToLeft ? 'padding-left: 68px;' : 'padding-right: 68px;')}
  }
`;
export const SpinnerLoaderStyled = styled(SpinnerLoader) `
  ${SpinnerLoaderMaskStyled} {
    position: static;
  }
`;
export const NonPointerEventsContainerStyled = styled.div `
  pointer-events: none;
`;
export const BottomSheetAutocompleteContainerStyled = styled.div `
  padding: 16px;

  ${DropDownListHolderStyled} {
    position: static;
  }
  input {
    ${({ isRightToLeft }) => (isRightToLeft ? 'padding-left: 68px;' : 'padding-right: 68px;')}
  }
`;
